// extracted by mini-css-extract-plugin
export default {"checkboxContainer":"EditConsentDocumentModal_checkboxContainer__bjOGF","checkboxTitle":"EditConsentDocumentModal_checkboxTitle__iEIJS"};